import { render, staticRenderFns } from "./MessageBody.vue?vue&type=template&id=36d59dd2&"
import script from "./MessageBody.vue?vue&type=script&lang=js&"
export * from "./MessageBody.vue?vue&type=script&lang=js&"
import style0 from "./MessageBody.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports